import type { ButtonGroupTheme } from './light'
import { commonDark } from '../../_styles/common'

const buttonGroupDark: ButtonGroupTheme = {
  name: 'ButtonGroup',
  common: commonDark
}

export default buttonGroupDark
